<div class="facebook-error-modal-container">
  <div class="modal-close-button" (click)="dismiss()">
    <i class="n2-ico n2-ico__search_x"></i>
  </div>
  <img src="assets/imgs/funz-warn.svg" />
  <div class="facebook-error-signup">{{'component.facebook-error.signup' | translate}}</div>
  <div class="facebook-error-details">{{'component.facebook-error.details' | translate}}</div>
</div>
<button class="close-btn" (click)="dismiss()">{{'component.facebook-error.ok' | translate}}</button>
